export function getStatusValue<T extends { Active: any; Inactive: any }>(
  isActive: boolean | null | undefined,
  StatusEnum: T
): T[keyof T] | [] {
  // needs to return an empty array to support status filters in the search store
  // this is only for the cases when the backend doesn't support the status as enum and provide true/false value
  if (isActive === undefined || isActive === null) {
    return []
  }
  return isActive ? StatusEnum.Active : StatusEnum.Inactive
}
